import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { LocalScanningWebApiService } from '../../services/local-scanning-web-api.service';
import { Observable, of } from 'rxjs';
import {
  DebugImageUrlsError,
  DebugImageUrlsReceived,
  DiagnosticsActions,
  ReprocessDocumentError,
  ReprocessDocumentFinished,
} from './diagnostics.actions';
import { IPayloadAction } from '../session/session.actions';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class DiagnosticsEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<any>>(Store);
  private webapi = inject(LocalScanningWebApiService);


  getDebugImageUrls$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(DiagnosticsActions.DIAGNOSTICS_DEBUG_IMAGE_URLS_GET),
    switchMap((action: IPayloadAction) => {
      return this.webapi.getDebugImageSignedUrls(action.payload)
        .pipe(
          catchError((e) => {
            // catch here; a catch on the main observable chain
            // would "complete" the observable and unsubscribe the effect
            return of(new DebugImageUrlsError(e));
          }),
        );
    }),
    switchMap((result: any) => {
      if (result.type === DiagnosticsActions.DIAGNOSTICS_DEBUG_IMAGE_URLS_ERROR) {
        return of(result);
      }
      return of(new DebugImageUrlsReceived(result));

    }),
  ));

  reprocessDocument$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(DiagnosticsActions.DIAGNOSTICS_REPROCESS),
    switchMap((action: IPayloadAction) => {
      console.log(`Reprocessing images as session ${action.payload.sessionId}`);
      return this.webapi.reprocess({
        scanIds: action.payload.result.scanIds,
        debug: action.payload.debug,
        sessionId: action.payload.sessionId,
      }).pipe(
        catchError((e) => {
          // catch here; a catch on the main observable chain
          // would "complete" the observable and unsubscribe the effect
          return of(new ReprocessDocumentError(e));
        })
      );
    }),
    switchMap((result: any) => {
      if (result.type === DiagnosticsActions.DIAGNOSTICS_REPROCESSING_ERROR) {
        return of(result);
      }
      return of(new ReprocessDocumentFinished());

    })
  ));
}
